import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"
import Table from "components/ui/Table"
import { STRING_TYPE } from "config"

const Content = () => {
  const HEADER = [
    {
      label: <strong>Küpsise nimi / sisu</strong>,
      field: "name",
      format: STRING_TYPE,
      minWidth: 100,
    },
    {
      label: <strong>Küpsise kirjeldus</strong>,
      field: "description",
      format: STRING_TYPE,
      minWidth: 100,
    },
  ]

  const ITEMS = [
    {
      name: "sessioonküpsised",
      description:
        "Seda küpsist kasutatakse iseteeninduses kasutaja autentimiseks ja autoriseerimiseks.",
    },
    {
      name: "kolmandate osapoolte küpsised",
      description:
        "Tegemist on analüütikaküpsistega, mida kogutakse kasutaja iseteeninduse kasutamise kohta, parandamaks kasutajakogemust. Rohkem infot: https://support.google.com/analytics/answer/11397207?hl=en&sjid=7820399061608210672-EU.",
    },
  ]

  return (
    <Fragment>
      <Accordion>
        <Summary>Mis on küpsised?</Summary>
        <Details>
          <Text>
            Küpsised on väikesed tähtedest ja numbritest koosnevad tekstifailid,
            mis laetakse alla ja salvestatakse veebilehe külastamisel teie
            arvutisse või muusse seadmesse (nt telefoni või tahvelarvutisse).
            Neid võidakse kasutada selleks, et salvestada teie sisestatud
            andmeid ja pidada meeles eelistusi (nt keelesätteid) sel ajal kui
            veebilehte sirvite või ka selleks, et saada tagasisidet, milliseid
            veebilehti külastate.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Milliseid küpsiste liike Fresh Finance kasutab?</Summary>
        <Details>
          <Text>
            Fresh Finance kasutab mitut liiki küpsiseid, mis erinevad
            kasutuseesmärgi ja talletamistähtaja poolest. Küpsiseid on vaja
            veebisaidi tehniliselt piisava toimimise tagamiseks, selle
            hõlpsamaks ning turvaliseks kasutamiseks ning isikupärase kogemuse
            loomiseks. Need võimaldavad meil pakkuda parimat iseteenindusse
            kogemust, saada teavet kuidas kliendid meie veebisaiti kasutavad ja
            teha teile pakutavad teenused paremaks.
          </Text>
          <Text>
            Talletamistähtaeg määrab, kui kaua need teie brauseris aktiivseks
            jäävad.
          </Text>
          <Text>Fresh Finance kasutab kolme liiki küpsiseid:</Text>
          <Text>
            <ul>
              <li>
                <strong>Rangelt vajalikud küpsised</strong> Rangelt vajalikud
                küpsised võimaldavad teile ligipääsu Fresh Finance veebisaidi
                eri osadele. Need küpsised salvestatakse teie arvutisse,
                mobiiltelefoni, tahvelarvutisse või muusse seadmesse sel ajal,
                kui te veebisaiti külastate. Need küpsised on veebisaidi tööks
                hädavajalikud ja neid ei saa välja lülitada. Vajalikke küpsiseid
                töödeldakse õigustatud huvi alusel. Sellest tulenevalt ei ole
                nende jaoks vaja kasutada nõusolekut.
              </li>
              <li>
                <strong>Analüütilised küpsised</strong> Analüütilised küpsised
                võimaldavad meil loendada külastusi ja veebiliikluse allikaid
                ning seeläbi veebisaidi mõõta ning parandada veebilehe jõudlust.
                Need võimaldavad meil näha, kuidas kasutajad veebisaidil
                liiguvad ning milliseid lehti rohkem külastatakse. Juhul, kui
                keeldute neid küpsiseid aktsepteerimast, ei kajastu teie
                külastus meie statistikas.
              </li>
              <li>
                <strong>Külastaja eelistused</strong> Neid küpsiseid kasutatakse
                selleks, parandada teie kasutajakogemust meie veebisaidil, anda
                asjakohast teavet meie toodete ja teenuste osas ning parandada
                meie sihtturundust ja reklaami. Neid küpsiseid võidakse kasutada
                ka meie reklaamkampaaniate jaoks kolmandate osapoolte
                veebilehtedel, mis võimaldab meil samuti saada teavet oma
                usaldusväärsete partnerite veebisaitide osas, kus olete meie
                reklaamidega kokku puutunud. Juhul, kui otsustate neist
                küpsistest keelduda, on teile näidatavad reklaamid vähem
                isikupärased.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Küpsiste nõusolek</Summary>
        <Details>
          <Text>
            Osade küpsiste puhul, mida kasutame analüüsi ja kasutaja eeliste
            eesmärgil, küsime teie nõusolekut. Kasutame neid küpsiseid
            isikupärastatud teabe esitamiseks ja meie veebilehe toimivuse
            parandamiseks. Kui annate nõusoleku kõigi küpsiste kasutamiseks,
            vajutage nuppu „Nõustun“. Kui soovite valida, milliste küpsistega
            nõustute, vajutage „Kohanda küpsiseid“. Küpsiste kasutamise
            nõusoleku saate anda või tagasi võtta ja oma eelistusi kohendada
            veebilehte külastades avaneva hüpikakna kaudu.
          </Text>
          <Text>Teie küpsiste valikut säilitatakse üks aasta.</Text>
          <Text>
            Kategooria aktsepteerimisel nõustute kõigi selle kategooria
            küpsistega. Selleks, et pakkuda parimat kasutajakogemust, võib Fresh
            Finance küpsiste kasutamist uuendada ja muuta ning seetõttu võib
            loend vastavalt muutuda.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Küpsiste eelistuste muutmine või tagasivõtmine</Summary>
        <Details>
          <Text>
            Teil on võimalik igal hetkel oma eelistusi kohandada, et valida,
            millised küpsiseid meil kasutada lubad. Samuti saate oma nõusoleku
            igal hetkel tagasi võtta. Siinkohal tasub silmas pidada, et küpsiste
            eemaldamine ja/või blokeerimine võib mõjutada teie kasutajakogemust.
            See võib avaldada mõju veebilehitseja tööle ja iseteeninduse
            korrektsele toimimisele.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Andmete töötlemine</Summary>
        <Details>
          <Text>
            Juhul, kui töötleme küpsiste kasutamisega seoses isikuandmeid,
            toimub see vastavalt <a href="/privacy">Privaatsusteatele</a>.
          </Text>
          <Text>Teil on kasutaja kui andmesubjektina õigus:</Text>
          <Text>
            <ul>
              <li>
                saada kinnitus, kui kasutaja isikuandmeid töötleb Fresh Finance,
                ja saada neile juurdepääs;
              </li>
              <li>piirata ja muuta isikuandmete töötlemise ulatust;</li>
              <li>nõuda isikuandmete kustutamist;</li>
              <li>
                kui isikuandmete töötlemine toimub Fresh Finance õigustatud huvi
                alusel, esitada vastuväited nende töötlemisele;
              </li>
              <li>
                võtta igal ajal tagasi nõusolek isikuandmete töötlemiseks;
              </li>
              <li>
                esitada isikuandmete töötlemisega kaebuse Eesti Andmekaitse
                Inspektsioonile (
                <a
                  href="https://www.aki.ee/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.aki.ee
                </a>
                ), kui leiate, et Fresh Finance poolt toimuv töötlemine riivab
                teie õigusi ja huve andmekaitset reguleerivaid õigusaktide
                silmas pidades.
              </li>
            </ul>
          </Text>
          <Text>
            Kasutaja saab õiguste teostamiseks esitada päringu läbi
            iseteeninduse, või saates e-kirjaga päringu digiallkirjastatuna{" "}
            <a href="mailto:support@freshfinance.ee">support@freshfinance.ee</a>
            .
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Kontaktandmed</Summary>
        <Details>
          <Text>
            Kui teil on küsimusi küpsiste kasutamise ja kohandamise, nõusoleku
            tagasivõtmise või küpsistega seonduva teemaga, võtke palun meiega
            ühendust. Meie kontaktandmed on saadaval Fresh Finance kodulehel.
          </Text>
          <Text>
            Samuti on teil võimalus ühendust võtta meie
            andmekaitsespetsialistiga, saates e-kiri aadressile{" "}
            <a href="mailto:support@freshfinance.ee">support@freshfinance.ee</a>
            .
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Dokumendi kehtivus</Summary>
        <Details>
          <Text>
            Küpsiste kasutamise eeskiri koostatakse eesti keeles ning tõlgitakse
            inglise keelde. Vaidluste, argumentide või keeleliste ja
            tõlgendamisega seotud vaidluste korral on selle küpsiste kasutamise
            eeskirja õiguslikult siduv versioon eestikeelsena.
          </Text>
          <Text>
            Küpsiste kasutamise eeskiri 18. veebruarist 2025. Fresh Finance-l on
            õigus antud küpsiste kasutamise eeskirja igal ajal ühepoolselt
            muuta. Kõik muudatused avaldatakse ja uusim versioon on{" "}
            <a
              href="https://freshfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.freshfinance.ee
            </a>
            .
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Hetkel rakenduses olevad küpsised</Summary>
        <Details>
          <Table header={HEADER} items={ITEMS} fade={false} />
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
